<template>
  <div>
    <!-- on-ok="handleOk" :closable="false" -->
    <a-modal v-model="viewModal" :width="1500" title="Import Update Alumni Member" :closable="false" :maskClosable="false">
      <template slot="footer">
        <a-button @click="onCloseDataModal"> close </a-button>
        <a-button @click="onSubmitImport" :loading="!isLoaded" type="primary">
          Submit Upload
          <!-- {{ countInsert }} -->
        </a-button>
      </template>
      <!-- {{ fileList }} -->
      <h6 class="mt-5 mb-10">
        Input Data
        <p class="mt-0 mb-0">
          Example file :
          <a target="_blank"
            href="https://docs.google.com/spreadsheets/d/1UKb5cKuzBd14uoG8PEpaFxHkx0L8PnAaagqPWPm36mM/edit?usp=sharing">File
            (.xlsx)</a>
        </p>
      </h6>
      <a-upload-dragger name="file" :file-list="fileList" @change="handleChange">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">Click or drag file to this area to upload</p>
      </a-upload-dragger>
      <br />
      <!-- <div class="modal-info"> -->

      <a-row>
        <a-col :span="4">
          <a-tag color="green">
            <p class="text-center mt-5 mb-0 font-bold">
              Alumni
              <span class="text-danger">{{ dataTable.length }}</span> person
            </p>
          </a-tag>
        </a-col>
        <a-col :span="16">
          <span v-if="!isLoaded">
            <a-progress :stroke-color="{
              from: '#108ee9',
              to: '#87d068',
            }" :percent="importProgress" status="active" />
          </span>
        </a-col>
        <a-col :span="4" style="text-align:right">
          <a-tag color="blue">
            <p class="text-center mt-5 mb-0 font-bold">
              Complete :
              <span class="text-info">{{ importComplete }}</span>
            </p>
          </a-tag>
          <a-tag color="red">
            <p class="text-center mt-5 mb-0 font-bold">
              Failed :
              <span class="text-danger">{{ importFailed }}</span>
            </p>
          </a-tag>
        </a-col>
      </a-row>


      <a-table bordered :columns="columns" :data-source="dataTable" :loading="loadingSetTable" :pagination="true"
        size="small" class="mt-20 mb-20" :scroll="{ x: 1500 }">
        <template slot="status_import" slot-scope="text, record, index">
          <div>
            <a-icon :style="{ fontSize: '25px', color: '#F55050' }" v-if="text === 'error'" type="exclamation-circle" />
            <a-icon :style="{ fontSize: '25px', color: '#1F8A70' }" v-if="text === 'complete'" type="check-square" />
          </div>
        </template>

        <template slot="status_detail" slot-scope="text, record, index">
          <span v-if="record.status_import === 'error'">
            <p :style="{ color: '#F55050' }">{{ text }}</p>
          </span>
          <span v-if="record.status_import === 'complete'">
            <p :style="{ color: '#1F8A70' }">Import Complete</p>
          </span>
        </template>
      </a-table>

      <!-- </div> -->
      <p class="mt-0 mb-0">{{ indexLoad }}</p>
    </a-modal>
  </div>
</template>

<script>
import readXlsxFile from "read-excel-file";
import _tableUpload from "./table-import/tableImportAlumniMember.js";

export default {
  props: {
    viewModal: {
      type: Boolean,
      default: false,
    },
    onCloseModal: {
      type: Function
    }
  },
  data() {
    return {
      // table connect api status
      indexLoad: "",
      processImport: [],
      //
      dataTable: [],
      columns: _tableUpload.excleHead,
      // file upload
      fileList: [],
      uploading: false,
      errorFile: "",
      loading: false,
      //
      loadingSetTable: false,
      // count load
      countInsert: 0,
      //loading
      isLoaded: true,
      //amount import
      importComplete: 0,
      importFailed: 0
    };
  },
  mounted() {
  },
  computed: {
    importProgress() {
      if (this.dataTable.length === 0) return 0;
      return Number.parseFloat((this.importComplete + this.importFailed) * 100 / this.dataTable.length).toFixed(2);
    }
  },
  methods: {
    onCloseDataModal() {
      this.fileList = [];
      this.dataTable = []
      this.onCloseModal();
    },
    checkBlank(val) {
      return !["", null, "null"].includes(val) ? val : "-";
    },
    handleChange(info) {
      this.loadingSetTable = true;
      this.importComplete = 0
      this.importFailed = 0
      this.dataTable = [];
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      this.processImport = [];

      // 2. read from response and show file link
      fileList = fileList.map((file) => {
        if (file.response) {
          let xlsxfile = info.file.originFileObj;
          readXlsxFile(xlsxfile).then((rows) => {
            for (let index = 0; index < rows.length; index++) {
              this.processImport.push({
                index: index,
                status: "wait",
                student_id: rows[index][1],
              });

              //console.log(rows[index]);
              if (index > 1) {
                this.dataTable.push({
                  // status import
                  status_import: "",
                  //describe
                  status_detail: "",
                  // not use
                  sequence: index, // not use
                  // not use
                  student_id: rows[index][1],
                  membership_id: this.checkBlank(rows[index][2]),
                  muicaa_member: this.checkBlank(rows[index][3]),
                });
              }
            }
          });
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
      this.loadingSetTable = false;
    },
    updateMainProfile(jsonData, id) {
      return new Promise((resolve) => {
        this.$http
          .patch(
            "/student_affair/alumni-profile/" + id + "/",
            jsonData
          )
          .then((response) => {
            if (response.status) {
              resolve(true);
            }
          })
          .catch((error) => {
            //console.log(error);
            resolve(false);
          });
      });
    },
    getStudentProfile(studentID) {
      return new Promise((resolve) => {
        this.$http
          .get(
            "student_affair/alumni-profile/?student_id=" + studentID)
          .then((response) => {
            if (response.status == 200 & response.data.length > 0) {
              //console.log("std ID " + studentID);
              resolve(response.data);
            } else {
              resolve([]);
            }
          })
          .catch((error) => {
            //console.log(error);
            resolve([]);
          });
      });
    },
    async onSubmitImport() {
      //console.log(this.dataTable.length)
      this.isLoaded = false;
      for (let i = 0; i < this.dataTable.length; i++) {
        let recData = this.dataTable[i];
        let dataProfile = await this.getStudentProfile(recData['student_id']);
        if (dataProfile.length > 0) {
          let studentProfile = dataProfile[0]
          try {
            let jsonBodyMain = {}
            if (recData['membership_id'] !== '-' && recData['membership_id'] !== null) {
               jsonBodyMain["membership_id"] = recData['membership_id'];
            }
             if (recData['muicaa_member'] !== '-' && recData['muicaa_member'] !== null) {
               jsonBodyMain["muicaa_member"] = recData['muicaa_member'];
            }
            
            // Check if there is anything to update
            if (Object.keys(jsonBodyMain).length > 0) {
                let isSuccessed = await this.updateMainProfile(jsonBodyMain, studentProfile['id']);
                if (isSuccessed) {
                  this.dataTable[i]['status_import'] = 'complete'
                  this.importComplete++
                }
                else {
                    this.dataTable[i]['status_import'] = 'error'
                    this.dataTable[i]['status_detail'] = 'Update failed.'
                    this.importFailed++
                }
            } else {
                // Nothing to update
                this.dataTable[i]['status_import'] = 'complete'
                this.dataTable[i]['status_detail'] = 'Nothing to update.'
                this.importComplete++
            }

          } catch (error) {
            //console.log(error)
            this.dataTable[i]['status_import'] = 'error'
            this.dataTable[i]['status_detail'] = 'Update error.'
            this.importFailed++
          }
        } else {
          this.dataTable[i]['status_import'] = 'error'
          this.dataTable[i]['status_detail'] = 'Student ID not found.'
          this.importFailed++
        }
      }
      this.isLoaded = true;
    },
  },
};
</script>
<style>
.modal-info {
  overflow-y: scroll;
  max-height: 500px;
}
</style>